import {RouteKey} from 'common/src/modules/routing/routing.enums';
import {z} from 'zod';

const pathParamValuesSchema = z.array(
  z.object({
    key: z.string(),
    value: z.union([z.string(), z.number()]),
  }),
);

const queryParamValuesSchema = z.array(
  z.object({
    key: z.string(),
    value: z.union([z.string(), z.number(), z.array(z.string()), z.array(z.number())]),
  }),
);

const promptToRouteResponseSchema = z.object({
  success: z.boolean(),
  routeKey: z
    .nativeEnum(RouteKey)
    .nullable()
    .describe('The path of the selected route definition, null if more info needed'),
  pathParamValues: pathParamValuesSchema.describe('Values for the path parameters'),
  queryParamValues: queryParamValuesSchema.describe('Values for the query parameters'),
  confidence: z
    .number()
    .min(0)
    .max(100)
    .describe('Confidence level (0-100) in the route selection'),
  reasoning: z.string().describe('Brief explanation of why this route was selected'),
  missingInfo: z.string().describe('List of missing required information when success is false'),
});

export {promptToRouteResponseSchema};
